export const CIP_SHORT_ALIASES = {
    // Example CIP codes with significantly long names:
  
    // 470607 "Aircraft Mechanic and Aircraft Maintenance Technology/Technician"
    "470607": "Aircraft Mech & Maint.",
  
    // 100290 "Visual Communications Foundations"
    "100290": "Visual Comm Foundations",
  
    // 500502 "Technical Theater/Theater Design and Technology/Technician"
    "500502": "Technical Theater & Design",
  
    // 150505 "Solar and Wind Energy Technology"
    "150505": "Solar & Wind Energy Tech",
  
    // 430100 "Public Safety and Security Foundations"
    "430100": "Public Safety & Security Found.",
  
    // 470201 "HVAC/HVACR Maintenance Technology/Technician"
    "470201": "HVAC Maintenance Tech",
  
    // 100304
    // "Animation, Interactive Technology, Video Graphics and Special Effects"
    "100304": "Animation & Video Effects",
  
    // 030601 "Wildlife and Wild Lands Science and Management"
    "030601": "Wildlife & Wild Lands Mgmt",
  
    // 261201 "Agricultural Biotechnology"
    "261201": "Ag Biotechnology",
  
    // 469998 "Pre-Apprenticeship Skills for the Trades"
    "469998": "Pre-Apprenticeship Skills",
  
    // 120500 "Foods and Related Culinary Arts Foundations"
    "120500": "Foods & Culinary Arts Found.",
  
    // 168888 "Linguistics Cooperative Worksite Experience"
    "168888": "Linguistics Coop Worksite Exp",
  
    // 521101 "International Business/Trade/Commerce"
    "521101": "International Business/Trade",
  
    // 010606 "Plant Nursery Operations and Management"
    "010606": "Plant Nursery Ops & Mgmt",
  
    // 010602
    // "Plant Systems Operation(s) and Management in Horticulture and Greenhouses"
    "010602": "Plant Systems Ops & Mgmt (Hort)",
  
    // 141801 "Introduction to Materials Engineering"
    "141801": "Intro to Materials Eng.",
  
    // 108888 "Communication Technologies Cooperative Worksite Experience"
    "108888": "Comm Tech Coop Worksite Exp",
  
    // 140501
    // "Biotechnical Engineering and Biomedical Engineering"
    "140501": "Biotech & Biomedical Eng.",
  
    // 118888
    // "Computer and Information Sciences and Support Services Cooperative Worksite Experience"
    "118888": "Comp/Info Sci Support Coop Exp",
  
    // 128888
    // "Personal and Culinary Services Cooperative Worksite Experience"
    "128888": "Culinary Services Coop Exp",
  
    // 510000 "Introduction to Health Sciences Careers"
    "510000": "Intro Health Sci Careers",
  
    // 149994 "Introduction to Science Research in Engineering"
    "149994": "Intro Sci Research in Eng.",
  
    // 460100 "Architecture and Construction Foundations"
    "460100": "Arch & Construction Found.",
  
    // 218888 "Technology Education Cooperative Worksite Experience"
    "218888": "Tech Ed Coop Worksite Exp",
  
    // 030506 "Forest Management/Forest Resources Management"
    "030506": "Forest Mgmt & Resources",
  
    // 150801 "Aeronautical and Aerospace Engineering Technology"
    "150801": "Aero & Aerospace Eng. Tech",
  
    // 030205 "Water, Wetlands and Marine Resources Management"
    "030205": "Water/Wetlands/Marine Mgmt",
  
    // 521804 "Selling Skills and Sales Operations"
    "521804": "Selling Skills & Operations",
  
    // 158888 "Engineering Technologies Cooperative Worksite Experience"
    "158888": "Eng Tech Coop Worksite Exp",
  
    // 010102 "Agribusiness/Agricultural Business Operations"
    "010102": "Agribusiness/Ag Bus Ops",
  
    // 110801
    // "Web Page, Digital/Multimedia and Information Resources Design"
    "110801": "Web Page & Multimedia Design",
  
    // 510805 "Pharmacy Pre-Technician/Assistant"
    "510805": "Pharmacy Pre-Tech",
  
    // 490102 "Airline/Commercial Pilot and Flight Crew"
    "490102": "Airline/Comm. Pilot & Crew",
  
    // 030202
    // "Sustainable Design and Technology – Agriculture and Natural Resources Application"
    "030202": "Sustain. Design/Tech (Ag/NR)",
  
    // 151301 "Drafting and Design Technology,General"
    "151301": "Drafting & Design Technology",
  
    // 401099 "Materials Science Technology Applied"
    "401099": "Materials Science Tech",
  
    // 010205 "Agricultural Mechanics and Equipment/Machine Technology"
    "010205": "Ag Mechanics & Equip Tech",
  
    // 288888
    // "Government and Public Administration Cooperative Worksite Experience"
    "288888": "Gov/Public Admin Coop Exp",
  
  
    // 500797 "Professional Production Arts Technology/Technician"
    "500797": "Prof Production Arts Tech",
  
    // 520401
    // "Business Procedures and Administrative Support Services"
    "520401": "Biz Procedures & Admin Support",
  
    // 470616
    // "Marine Maintenance and Ship Repair Technology/Technician"
    "470616": "Marine Maint/Ship Repair Tech",
  
    // 038888
    // "Natural Resources and Conservation Cooperative Worksite Experience"
    "038888": "Nat. Resources/Conservation Coop",
  
    // 144201 "Mechatronics and Industrial Automation"
    "144201": "Mechatronics & Industrial Auto",
  
    // 228888
    // "Legal Professions and Studies Cooperative Worksite Experience"
    "228888": "Legal Professions Coop Exp",
  
    // 190726
    // "GRADS (Graduation, Reality and Dual Skills)"
    "190726": "GRADS",
  
    // 190703 "Career, Community and Family Connections"
    "190703": "Career/Comm/Family Connections",
  
    // 110802 "Data Modeling and Database Administration"
    "110802": "Data Modeling & DB Admin",
  
    // 520703 "Small Business Administration/Management"
    "520703": "Small Biz Admin/Mgmt",
  
    // 190601 "Housing, Interiors and Furnishings"
    "190601": "Housing, Interiors/Furnishings",
  
    // 100305
    // "Graphics and Printing Equipment Operator and General Production"
    "100305": "Graphics/Printing Operator",
  
    // 018888 "Agriculture Cooperative Worksite Experience"
    "018888": "Ag Coop Worksite Exp",
  
    // 520803 "Banking and Financial Support Services"
    "520803": "Banking & Financial Services",
  
    // 520302
    // "Accounting Technology/Technician and Bookkeeping"
    "520302": "Accounting Tech & Bookkeeping",
  
    // 114) 470606
    // "Power Equipment Small Engine Technology/Technician"
    "470606": "Power/Small Engine Tech",
  
    // 318888
    // "Hospitality, Tourism and Recreation Cooperative Worksite Experience"
    "318888": "Hospitality/Tourism Coop Exp",
  
    // 110601 "Digital Communication Tools" – fairly short, skipping or optional
  
    // 528888
    // "Business and Marketing Education Cooperative Worksite Experience"
    "528888": "Biz/Marketing Ed Coop Exp",
  
    // 090701 "TV/Radio Broadcast Journalism Technology"
    "090701": "TV/Radio Broadcast Journalism",
  
    // 100301 "Graphic Communications Foundations"
    "100301": "Graphic Comm Foundations",
  
    // 110103 "Fundamentals of Information Technology" – borderline length, optional skip
  
    // 500602 "Cinematography and Cinema Production"
    "500602": "Cinematography & Cinema Prod",
  
    // 310101 "Hospitality, Tourism and Recreation"
    "310101": "Hospitality/Tourism/Recreation",
  
    // 151302 "CAD/CADD Drafting and/or Design Technology"
    "151302": "CAD/CADD Drafting/Design Tech",
  
    // 100303
    // "Prepress/Desktop Publishing and Digital Imaging Technology/Technician"
    "100303": "Prepress/Desktop & Imaging Tech",
  
    // 100201 "Photography and Video Foundations"
    "100201": "Photo & Video Foundations",
  
    // 430109 "Homeland Security and Loss Prevention Services"
    "430109": "Homeland Security & Loss Prev.",
  
    // 518888
    // "Health Sciences Careers Cooperative Worksite Experience"
    "518888": "Health Sciences Coop Exp",
  
    // 500402 "Graphic Design/Commercial and Advertising Art"
    "500402": "Graphic Design & Advertising",
  
    // 480703 "Cabinetmaking and Millwork/Mill Wright"
    "480703": "Cabinetmaking & Millwright",
  
    // 468888
    // "Construction Trades Cooperative Worksite Experience"
    "468888": "Construction Trades Coop Exp",
  
    // 151202 "Computer Technology/Computer Systems Technology"
    "151202": "Computer Tech/Systems Tech",
  
    // 100203
    // "Recording Arts and Sound Reinforcement Technology"
    "100203": "Recording Arts & Sound Tech",
  
    // 098888 "Communication/Journalism Cooperative Worksite Experience"
    "098888": "Comm/Journalism Coop Exp",
  
    // 149996 "Introduction to Computer Integrated Manufacturing"
    "149996": "Intro to Computer Integrated Mfg",
  
    // 110803
    // "Video Game Design/Digital Computer Animation for Game Design"
    "110803": "Video Game Design & Animation",
  
    // 500499 "Design and Commercial Art Foundations"
    "500499": "Design & Commercial Art Found.",
  
    // 120410 "Nail Technician/Specialist and Manicurist"
    "120410": "Nail Tech & Manicurist",
  
    // 520905 "Restaurant/Food Services Management"
    "520905": "Restaurant/Food Services Mgmt",
  
    // 310504
    // "Sports Recreation and Entertainment Marketing and Management"
    "310504": "Sports Rec & Ent. Marketing/Mgmt",
  
    // 430106
    // "Forensic Science Technology/Crime Scene Investigation"
    "430106": "Forensic Sci/Crime Scene Invest",
  
    // 151304
    // "Civil Drafting and Civil Engineering CAD/CADD"
    "151304": "Civil Drafting & Engr CAD/CADD",
  };